import React, { Component } from "react";
import AceAlertsEntries from "../../ace/AceAlertsEntries";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { requestPageOfAceAlert } from "./storeAceAlerts/action";
import "../CaseSelector/CaseSelector.css";
import "./Admin.css";
import axios from "axios";
import { apiUri } from "../../config";
import Paginator from "../../hoc/Paginator/Paginator";
import { NotificationManager } from "react-notifications";
import moment from "moment";
import InputSearch from "./../../common/components/Search/InputSearch";
import "react-datepicker/dist/react-datepicker.css";

class AceAlertsManagement extends Component {
	constructor(props) {
		super(props);
		this.state = {
			searchValue: "",
			searchArray: [],
			currentDandOs: [],
			sortValue: "",
			sortOrder: "",
			searching: false,
			searchData: [],
			openAddModal: false,
			openImportModal: false,
			addCaseData: {
				comapnyName: "",
				riskAssessmentDate: moment(),
				riskAssessmentDate_UI: "",
				ticker: "",
				purchased: false,
				enabled: false,
				market: "",
				caseFile: "",
				identifier: "",
				sicCode: "",
				cik: "",
				firmId: "",
				lastUpdated: "",
				dateAdded: "",
				indexListId: -1,
				comapnyNameError: "",
				riskAssessmentDateError: "",
				tickerError: "",
				sicCodeError: "",
				cikError: "",
				marketError: "",
				caseFileError: "",
				indexListIdError: "",
				identifierError: ""
			},
			indexList:[]
		};
		this.handleClick = this.handleClick.bind(this);
		this.handleSaveFileData = this.handleSaveFileData.bind(this);
		this.handleSaveStatus = this.handleSaveStatus.bind(this);
		this.handleClear = this.handleClear.bind(this);
		
		this.handleCreateCancel = this.handleCreateCancel.bind(this);
	
	}

	importLogs = (data) => {
		let self = this;
		localStorage.removeItem("timestamp");
		axios
			.get(apiUri + "/dando/runImporter")
			.then(json => {
				if (json.data && json.data.statusCode === 200) {
					NotificationManager.success(json.data.statusMessage, "Success");
				} else {
					NotificationManager.error(json.data.statusMessage, "Failure");
				}
			})
			.catch(err => {
				console.log(err);
			});

		this.setState({ openImportModal: true });
		var tmLoc = new Date();
		let T2 = tmLoc.getTime() + tmLoc.getTimezoneOffset() * 60000;
		localStorage.setItem("timestamp", T2);
		axios
			.get(apiUri + "/admin/getLogs")
			.then(json => {
				if (json.data) {
					self.setState({ logsData: json.data.content });
				}
			})
			.catch(err => {
				console.log(err);
			});
	};
	
	getLogs = () => { 
		let self = this;
		axios
			.get(apiUri + "/admin/getLogs") 
			.then(json => {
				if (json.data) {
					self.setState({ logsData: json.data.content });
				}
			})
			.catch(err => {
				console.log(err);
			});
	};

	goToAceAlertCases = (alertId) => {
        alert("alertt entereed")
		this.props.history.push("/cases/" + alertId);
	};

	handleSaveFileData = (data, _onCloseModal) => {
	 
		if (data) {
			let RiskDate =
			new Date(data.riskAssessmentDate).getFullYear() +
			"-" +
			("0" + (new Date(data.riskAssessmentDate).getMonth() + 1)).slice(-2) +
			"-" +
			("0" + new Date(data.riskAssessmentDate).getDate()).slice(-2);
			let obj = {
				alertId: data.alertId,
				symbol: data.ticker,
				companyName: data.companyName,
				riskAssessmentDate: RiskDate,
				purchased: data.dateAdded,
				enabled: data.enabled,
				status: data.status,
				sicCode: data.sicCode,
				cik: data.cik,
				market: data.market,
				caseFile: data.caseFile,
				identifier: data.identifier,
				indexListId: data.indexListId
			};
			
			axios
			.put(apiUri + "/alert/" + data.alertId, obj)
			.then(json => {
				if (json.data && json.data.statusCode === 200) {
					this.props.searchSortData(
						this.props.currentPage,
						this.state.sortValue,
						this.state.sortOrder
					);
					NotificationManager.success(json.data.statusMessage);
					_onCloseModal();
				}
			})
			.catch(err => {
				console.log(err);
			});
		}
	};
	handleSaveStatus = data => {
		if (data) {
			axios
			.patch(apiUri + "/alert/updateEnable/"+data.alertId+"?enable="+data.enabled)
			.then(json => {
					if (json.data && json.data.statusCode === 202) {
					this.props.searchSortData(
						this.props.currentPage,
						this.state.sortValue,
						this.state.sortOrder
					);
					NotificationManager.success(json.data.statusMessage, "Success");
				}
			})
			.catch(err => {
				console.log(err);
			});
		}
	};
	

	onCloseModal = () => {
		this.setState({ open: false, openAddModal: false });
	};

	handleSorting = (key, order) => {
		this.setState({ sortValue: key, sortOrder: order });
		let obj = {
			sortValue: key,
			sortOrder: order
		};
		localStorage.setItem("sortParams", JSON.stringify(obj));
		this.props.searchSortData(0, key, order);
	};

	componentDidMount() {
		
		let page = this.props.currentPage;
		this.props.searchSortData(
			page,
			this.state.sortValue,
			this.state.sortOrder
		);
	};

	handleClick(searchValue) {
		localStorage.setItem("searchValue", JSON.stringify(searchValue));
		sessionStorage.setItem('tempSearchValue',searchValue)
		var obj = JSON.parse(localStorage.getItem("sortParams"));
		const {sortValue='', sortOrder=''} = obj || {};
		this.setState({ searchValue, sortValue, sortOrder });
		this.props.searchSortData(0, sortValue, sortOrder);
	};

	handleClear() {
		this.setState({ searchValue: "" });
		localStorage.removeItem("sortParams");
		this.setState({sortOrder:'',sortValue:''})
		localStorage.removeItem("searchValue");
		sessionStorage.removeItem('tempSearchValue')
		this.props.searchSortData(0);
	};
	
	
	handleCreateCancel() {
		this.setState({ openAddModal: false, addCaseData: {} });
	}

	componentDidUpdate(){
		window.onpopstate  = (e) => {
			e.preventDefault();
			var tempSearchValue = sessionStorage.getItem('tempSearchValue')

			if(tempSearchValue){
				setTimeout(()=>{
					localStorage.setItem("searchValue", JSON.stringify(tempSearchValue));
					this.props.searchSortData(this.props.currentPage);
				},100)

				this.setState({ searchValue: tempSearchValue })

			}
			var obj = JSON.parse(localStorage.getItem("sortParams"));
			if(obj){
				this.setState({
					sortValue:obj.sortValue,
					sortOrder:obj.sortOrder
				})

				setTimeout(()=>{
					this.props.searchSortData(this.props.currentPage, obj.sortValue, obj.sortOrder);
				},200) 
			}
		}
	};

	render() {
	
	return (
		<React.Fragment>
		<div
			style={{ display: "flex", justifyContent: "space-between" }}
			className={"CustomCaseManagementTitle"}
		>
			<span>ACE Alert&reg; Management</span>
			<div
			style={{
				display: "flex",
				justifyContent: "space-between",
				width: "180"
			}}
			>

			<InputSearch
				searchText={this.state.searchValue}
				handleSearch={this.handleClick}
				handleClear={this.handleClear}
			/>

			&nbsp; &nbsp;
			</div>
		</div>
		{this.props.currentAceAlert.length > 0 ? (
			<AceAlertsEntries
			aceAlerts={this.props.currentAceAlert}
			sortValue={this.state.sortValue}
			sortOrder={this.state.sortOrder}
			goToAceAlertCases={(data)=>this.goToAceAlertCases(data)}
			handleEdit={this.handleEdit}
			handleDelete={this.handleDelete}
			handleSaveFileData={this.handleSaveFileData}
			handleSaveStatus={this.handleSaveStatus}
			handleSorting={this.handleSorting}
			/>
		) : (
			<div className="widthfull">
			<table className="widthfull">
				<tbody>
				<tr>
				<td className="norecords">
					<span>Loading ...</span>
				</td>
				</tr>
				</tbody>
			</table>
			</div>
		)}
		{this.props.currentAceAlert.length > 0 ? (
			<Paginator
				name={"case-selector"}
				totalPages={this.props.totalPages}
				currentPage={this.props.currentPage}
				setPage={(pageNumber)=>this.props.searchSortData(pageNumber, this.state.sortValue, this.state.sortOrder)}
			/>
		) : (
			""
		)}
		</React.Fragment>
	);
	}
}

const mapStateToProps = state => {
	return {
		currentAceAlert: state.aceAlertsAdmin.currentAceAlert,
		currentPage: state.aceAlertsAdmin.currentPage,
		totalAceAlerts: state.aceAlertsAdmin.totalCases,
		totalPages: state.aceAlertsAdmin.totalPages
	};
};

const mapDispatchToProps = dispatch => {
	return {
		searchSortData: (currentPage, sortValue, sortOrder) =>
			dispatch(requestPageOfAceAlert(currentPage, sortValue, sortOrder))
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withRouter(AceAlertsManagement));



// WEBPACK FOOTER //
// ./src/components/Admin/AceAlertsManagament.js